import da from 'dayjs/locale/da';
import de from 'dayjs/locale/de';
import en from 'dayjs/locale/en';
import en_gb from 'dayjs/locale/en-gb';
import es_us from 'dayjs/locale/es-us';
import et from 'dayjs/locale/et';
import fr from 'dayjs/locale/fr';
import lt from 'dayjs/locale/lt';
import nl from 'dayjs/locale/nl';
import pt from 'dayjs/locale/pt';
import ro from 'dayjs/locale/ro';
import bg from 'dayjs/locale/bg';
import sv from 'dayjs/locale/sv';

export default {
  languages: {
    da: 'Dansk',
    de: 'Deutsch',
    'en-US': 'English (US)',
    'en-GB': 'English (Great Britain)',
    'es-CO': 'Español (Colombia)',
    'fr-FR': 'Français',
    'nl-NL': 'Nederlands',
    'no-NO': 'Norsk',
    'sv-SE': 'Svenska',
    'it-IT': 'Italiano',
    'pl-PL': 'Polski',
    pt: 'Português',
    'ru-RU': 'Русский',
    'hr-HR': 'Hrvatski',
    uk: 'Yкраїнська',
    'fi-FI': 'Suomi',
    'lt-LT': 'Lietuvių',
    'et-EE': 'Eesti',
    'ro-RO': 'Română',
    'bg-BG': 'Български',
  },
  mt: 'Deliveries',
};

export const supportedLocales = {
  da: da,
  de: de,
  'en-US': en,
  'en-GB': en_gb,
  'es-CO': es_us,
  'fr-FR': fr,
  'nl-NL': nl,
  'sv-SE': sv,
  pt,
  'ro-RO': ro,
  'bg-BG': bg,
  'lt-LT': lt,
  'et-EE': et,
};
